import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { ProductBarcode, ProductBarcodeCreate, ProductBarcodeFilter } from '../data/productBarcode';

export function createProductBarcodeService(client: AxiosInstance) {
  return createCrudService<ProductBarcode, ProductBarcodeCreate, ProductBarcodeFilter>(
    client,
    '/master-data/ProductBarcode',
    'id',
  );
}

export type ProductBarcodeService = CrudService<ProductBarcode, ProductBarcodeCreate, ProductBarcodeFilter>;
